import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from '@/i18n';
import Vue from "vue";
import $socket from "@/plugins/socket-instance";

export default {
  namespaced: true,
  state: {
    isActiveOutgoingCall: false,
    isSubscribed: false,
    fetched: false,
    notifies:[],
    telephonies:[]
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
    addNotify(state, notify){
      state.notifies.push(notify);
    }
  },
  actions: {
    async outgoingСall({commit, state, dispatch}, payload) { //исходящий звонок
      $socket.on(`outgoing-call-is-ended.${payload.hash}`, function(data) {
          updateField(state, {path:'isActiveOutgoingCall', value:false});
      });
      return axios.post(this._vm.$apiURL + '/make-outgoing-call', payload)
          .then((response) => {
            let data = response.data;
            updateField(state, {path:'isActiveOutgoingCall', value:true});
          })
          .catch((error) => {
            dispatch('common/showError', {'error': error}, {root: true});
          })
    },
    async subscribe({commit, state, dispatch}, hash) {
      if(state.isSubscribed) return;
      $socket.on(`call-to-shop.${hash}`, function(notify) { //подписка на событие о входящем звонке
        notify.show = true;
        commit('addNotify', notify)
      });
      updateField(state, {path:'isSubscribed', value:true});
    },
    get({ commit, state, dispatch }){
      updateField(state, {path:'fetched', value:true});
      axios.get(this._vm.$apiURL + '/telephonies')
          .then((response) => {
            let data = response.data;
            data.forEach((item) => {
              if (item.parameters.length === 0) {
                item.parameters[0] = {}
                item.parameters[0].parameters = {}
                for (let i in item.available_parameters) {
                  item.parameters[0].parameters[item.available_parameters[i].name] = null
                }
              }
            })
            updateField(state, {path: 'telephonies', value: data});
          })
          .catch((error) => {
            dispatch('common/showError', {'error': error}, {root: true});
          })
    },
    async update({ commit, state, dispatch }, payload){
      updateField(state, {path:'fetched', value:false});
      return axios.put(this._vm.$apiURL + '/telephonies/'+payload.id, payload)
          .then((response) => {
            this._vm.$inform(this._vm.i18n.t('common.operation_success'));
          })
          .catch((error) => {
            dispatch('common/showError', {'error': error}, {root:true});
            return Promise.reject()
          }).finally(()=>{
            updateField(state, {path:'fetched', value:true});
          })
    },
  }
}
